<template>
  <event-closed-form />
</template>

<script>
import EventClosedForm from '@/components/EventClosed/Form'

export default {
  components: {
    EventClosedForm
  },

  created: async function () {
    await this.$store.dispatch(
      'eventClosed/get',
      this.$route.params.id
    )
    this.$store.dispatch('eventClosed/initForm')
  }
}
</script>
